<script>
export default {
    name: "updataPwd",
    data() {
        return {
            password: '',
            newpassword: '',
            passwordAgain: '',
            isForget: false,
            phone: '',
            code: '',
            isLoading: false,
            isCodeLoading: false,
            countdown: 0,
            time: null,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        // 设置倒计时
        setCountdown() { 
            this.countdown = 3;
            if(this.time) clearInterval(this.time);
            this.time = setInterval(() => {
                this.countdown--;
                if(this.countdown <= 0) clearInterval(this.time);
            }, 1000)
        },
        // 获取验证码
        getCode() { 
            if (this.isCodeLoading) { 
                return;
            }
            if(this.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.phone.focus();
                this.$showToast({ text: '请输入手机号' });
                return false;
            }
            this.isCodeLoading = true;
            this.$store.dispatch('getCode', {
                phone: this.phone,
                type: 1
            }).then((result) => {
                this.isCodeLoading = false;
                if (result.code == 100) {
                    this.setCountdown();
                    this.$showToast({ text: '验证码已发送' });
                } else if (result.code == 101) { 
                    this.$showToast({ text: '验证码发送失败' });
                } else if (result.code == 102) { 
                    this.$showToast({ text: '已发送验证码，请勿重复获取' });
                    this.setCountdown();
                }
            }).catch((err) => {
                this.isCodeLoading = false;
                this.$showToast({ text: '验证码发送失败' });
            });
        },
        submit(){

        },
    },
};
</script>

<template>
    <div class="updataPwd">
        <p class="title">修改密码</p>
        <!-- 修改密码 -->
        <template v-if="!isForget">
            <div class="form edit">
                <div class="item">
                    <p class="name">现有密码：</p>
                    <input type="password" placeholder="请输入密码" ref="password" v-model="password"/>
                    <p class="text r">*</p>
                </div>
                <div class="item">
                    <p class="name">新密码：</p>
                    <input type="password" placeholder="请输入新密码" ref="newpassword" v-model="newpassword"/>
                    <p class="text r">*</p>
                </div>
                <div class="item">
                    <p class="name">重复新密码：</p>
                    <input type="password" placeholder="请再输入新密码" ref="passwordAgain" v-model="passwordAgain"/>
                    <p class="text r">*</p>
                </div>
                <div class="item">
                    <p>忘记密码？<a href="javascript:;" class="btn_forget" @click="isForget = true">重置密码</a></p>
                </div>
            </div>
            <div class="flex justify_end btn_bottom_group">
                <div class="btn_submit layout_flex_center" @click="submit">确认修改</div>
            </div>
        </template>
        <template v-else>
            <div class="form row edit">
                <div class="item">
                    <p class="name">电话号码：</p>
                    <input type="tel" placeholder="请输入手机号" ref="phone" v-model="phone"/>
                    <p class="text r">*</p>
                </div>
                <div class="item">
                    <p class="name">手机验证码：</p>
                    <input class="code" type="text" placeholder="请输入验证码" ref="code" v-model="code" maxlength="11"/>
                    <div class="btn_code layout_flex_center" v-if="isCodeLoading">
                        <Loading  type="smail"/>
                    </div>
                    <div class="btn_code layout_flex_center" v-else-if="countdown > 0">{{ countdown }}s</div>
                    <div class="btn_code layout_flex_center" @click="getCode" v-else>获取验证码</div>
                    <p class="text r">*</p>
                </div>
                <div class="item">
                    <p class="name">新密码：</p>
                    <input type="password" placeholder="请输入新密码" ref="newpassword" v-model="newpassword"/>
                    <p class="text r">*</p>
                </div>
                <div class="item"></div>
                <div class="item">
                    <p class="name">重复新密码：</p>
                    <input type="password" placeholder="请再输入新密码" ref="passwordAgain" v-model="passwordAgain"/>
                    <p class="text r">*</p>
                </div>
                <div class="item"></div>
                <div class="item">
                    <p><a href="javascript:;" class="btn_back" @click="isForget = false">&lt;返回</a></p>
                </div>
            </div>
            <div class="flex justify_end btn_bottom_group">
                <div class="btn_submit layout_flex_center" @click="submit">确认修改</div>
            </div>
        </template>
    </div>
</template>

<style scoped lang="scss">
.updataPwd{
    .btn_forget{
        border-bottom: 1px solid var(--font_color);
    }
    .btn_back{
        &:hover{
            border-bottom: 1px solid var(--font_color);
        }
    }
    .form{
        .item{
            width: calc(50% - .1rem);
        }
    }
}
</style>